// extracted by mini-css-extract-plugin
module.exports = {"tags":"Tags_tags__aWXwC","tagsItem":"Tags_tagsItem__R_CpU"};